import T from 'prop-types'
import React from 'react'
import Button from './Button'
import LoadingValue from './LoadingValue'

export default class SaveButton extends React.Component {
  static displayName = 'SaveButton'

  static propTypes = {
    el: T.oneOf(['span', 'a', 'button']),
    className: T.string,
    children: T.any,
    dirty: T.bool,
    disabled: T.bool,
    invalid: T.bool,
    isPrimary: T.bool,
    saveText: T.string,
    saving: T.bool,
    onSave: T.func.isRequired,
    onSaveArgs: T.array,
    tooltip: T.string,
    type: T.oneOf(['button', 'submit', 'reset'])
  }

  static defaultProps = {
    type: 'button',
    dirty: true,
    disabled: false,
    invalid: false,
    isPrimary: true,
    saveText: 'Save',
    onSaveArgs: [],
    saving: false
  }

  render() {
    const {
      className,
      el,
      dirty,
      disabled,
      invalid,
      isPrimary,
      saveText,
      saving,
      onSave,
      onSaveArgs,
      tooltip,
      type
    } = this.props

    const btnClass = invalid ? 'error' : (isPrimary ? (dirty ? 'primary' : 'default') : (dirty ? 'default' : ''))
    const isDisabled = disabled || saving || invalid

    return (
      <Button
        el={el}
        args={ onSaveArgs }
        className={ `btn btn-${ btnClass } ${className}` }
        data-tooltip={ tooltip }
        disabled={ isDisabled }
        onClick={ onSave }
        type={type}
      >
        { saving ? (
          <span>
            <LoadingValue light /> Saving
          </span>
        ) : (
          <span>
            { isPrimary && <span className="icon icon-checkmark" /> } { saveText }
          </span>
        ) }
      </Button>
    )
  }
}
